"use client";

import { Loader2 } from "lucide-react";
import { forwardRef } from "react";

interface InfiniteScrollLoaderProps {
  hasMore: boolean;
  isLoading: boolean;
  loadingText?: string;
  endText?: string;
  totalCount: number;
  pageSize: number;
}

export const InfiniteScrollLoader = forwardRef<HTMLDivElement, InfiniteScrollLoaderProps>(
  (
    {
      hasMore,
      isLoading,
      loadingText = "Memuat lainnya...",
      endText = "Semua sudah ditampilkan",
      totalCount,
      pageSize,
    },
    ref,
  ) => {
    return (
      <>
        {hasMore && (
          <div ref={ref} className="flex items-center justify-center py-6">
            {isLoading && (
              <div className="anim-fade text-muted-foreground flex items-center gap-2 text-sm">
                <Loader2 size={18} className="text-primary animate-spin" />
                {loadingText}
              </div>
            )}
          </div>
        )}

        {!hasMore && totalCount > pageSize && (
          <p className="text-foreground/30 py-4 text-center text-sm">{endText}</p>
        )}
      </>
    );
  },
);

InfiniteScrollLoader.displayName = "InfiniteScrollLoader";
